import {project1en, project1cz} from "./projects/project1"
import {project2en, project2cz} from "./projects/project2"
import {project3en, project3cz} from "./projects/project3"
import {project4en, project4cz} from "./projects/project4"

export const en = {
  projectsList: {
    project1en,
    project4en,
    project3en,
    project2en,
  },
  general: {
    title: "Title",
    coordination: "Coordination",
    participantsMuni: "Participants at Masaryk University",
    participantsOthers: "Collaborators at other institutions",
    funding: "Funding",
    projectAims: "Project aims",
    mainResults: "Main results",
    researchPapers: "Research papers"
  }
};

export const cz = {
  projectsList: {
    project1cz,
    project4cz,
    project3cz,
    project2cz,
  },
  general: {
    title: "Název",
    coordination: "Coordination",
    participantsMuni: "Participants at Masaryk University",
    participantsOthers: "Collaborators at other institutions",
    funding: "Funding",
    projectAims: "Cíle projektu",
    mainResults: "Hlavní výsledky",
    researchPapers: "Research papers"
  }
};
